import { Request } from "@tools/base";;
const { Axios } = Request;

const URL = "/v1/equity/";

//获取股票兑换列表
export function get_exchange_list(config?) {
  return Axios.get(URL + `balance/exchange/currency/list`, null, config);
}

// 股票兑换
export function exchange(config?) {
  return Axios.post(URL + `balance/exchange`, null, config);
}

// 股票兑换历史
export function exchange_history(config?) {
  return Axios.get(URL + `balance/exchange/history`, config);
}

// 股票兑换汇率 usdt-hkdj hkdj-usdt
export function exchange_convert(from, to, config?) {
  return Axios.get(URL + `balance/public/price/currency/${from}/convert/${to}`, null, config);
}